import { urlApi } from "../utils/strings";

export const getAnuncios = async ( ) => {

  const url = urlApi(`/anuncios/obtener_slider_anuncios.php`)
  const response = await fetch(url);
  const data = await response.json();

  if(data.sliders){
    return data.sliders.map((slider: any, index: number) => ({
      id: slider.id,
      imagen: slider.imagen,
      tipo: slider.tipo || '',
      orden: slider.orden ?? index,
      url: slider.url || '',
    }));
  }

  return [];

}

export const updateAnuncios = async ({data}:{data:any}) => {

  const url = urlApi(`/anuncios/guardar_slider_anuncios.php`)

  const response = await fetch(url, {
    method: 'POST',
    body: data,
  });

  const resp = await response.json();
  console.log(resp)
  if (response.ok) {
    console.log("Actualizado");
    return resp;
  } else {
    console.error('Error:');
    throw new Error('Error al actualizar anuncios');
  }

}